export default {
  index: [
    {
      path: '/bankfunds',
      component: resolve => require(['./bankfundsIndex_copy.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/bankfunds/_router.js